<template>
    <div id="contenedor-principal-adminContIntranet" class="container-fluid">
        <div id="encabezados">
            <h1>ADMINISTRACIÓN DE CONTENIDOS INTRANET</h1>
            <h4>Crea, elimina o modifica los contenidos de intranet</h4>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION CRUD CONTENIDOS INTRANET -->
        <div id="seccion-crud-contenidos" class="row">
            <!-- SECCION DE FILTROS DE BUSQUEDA -->
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2 pt-1">
                <CFiltrosDeContenidos 
                    v-on:AgregarNuevoContenido="evtNuevoContenido"
                    v-on:RealizarBusquedaDeMenus="evtBusquedaDeContenidos"
                    :key="busquedaContenidos.filtros.KEY + busquedaContenidos.filtros.contRender"></CFiltrosDeContenidos>
            </div>
            <!-- TABLA DE CONTENIDOS -->
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-2 pt-1">
                <div class="contenedor-color-negro p-0">
                    <div class="titulo-contenedores container-fluid">
                        <div class="form-inline justify-content-between">
                            <h5 class="font-weight-bold"><i class="fas fa-list"></i>&nbsp;&nbsp;Listado de contenidos</h5>
                            <i @click="evtInfoAyuda"
                               :class="[(busquedaContenidos.tabla.mostrarAyuda) ? 'i-info fas fa-question-circle' : 'i-info fas fa-caret-up']"></i>
                        </div>
                        <!-- INFORMACION DE AYUDA -->
                        <transition name="fade">
                            <div v-if="!busquedaContenidos.tabla.mostrarAyuda" id="contenedor-instrucciones" class="alert alert-dark mt-4 text-justify" role="alert">
                                <h4><strong>Instrucciones</strong></h4>
                                <h6>Dentro del listado de contenidos estaran habilitadas las acciones <strong>editar</strong> y <strong>eliminar</strong>, las cuales permitiran modificar un contenido o cambiar el estatus del contenido a inactivo.</h6>
                                <h6><strong>(*) Editar un contenido</strong>: para editar un contenido se debera dar click en el boton con el icono <i class="fas fa-pen"></i>, al realizar este paso se abrira un formulario con la informacion del contenido en donde se podra realizar cualquier modificacion necesaria, finalizando en el boton <strong>Guardar</strong> del formulario.</h6>
                                <h6><strong>(*) Cambiar contenido a inactivo</strong>: para cambiar a inactivo un contenido se debera marcar la casilla que esta en la primer columna del listado de contenidos <i class="fas fa-check-square"></i>, al realizar este paso se habilitara en la parte superior del listado un boton para eliminar el o los contenidos seleccionados.</h6>
                            </div>
                        </transition>
                    </div>
                    <!-- ACCIONES DE SELECCION EN TABLA -->
                    <div v-if="this.campoRequeridoEsValido(contenidosSeleccionados)" id="seccion-acciones-contSeleccionados">
                        <div class="form-inline justify-content-between">
                            <button type="button" @click="confirmarCambioDeEstatusAContenidos" class="btn-sm btn-danger"><i class="fas fa-times"></i>&nbsp;&nbsp;Eliminar</button>
                            <button type="button" @click="evtRemoverCedulasSeleccionadas" class="btn-sm btn-danger"><i class="fas fa-times"></i>&nbsp;&nbsp;Contenidos seleccionados:&nbsp;&nbsp; <strong>{{ contenidosSeleccionados.length }}</strong></button>
                        </div>
                    </div>
                    <div class="container-fluid contenedor-tabla-contenidos-intranet">
                        <div v-show="mostrarAccionOrdenamiento" id="accion-ordenar">
                            <h6 @click="evtMostrarModalOredenamientoDeContenidos" v-tooltip:left="'Modificar orden de los contenidos'">ordenar&nbsp;<i class="fas fa-sort-numeric-up"></i></h6>
                        </div>
                        <table
                            class="table table-striped table-light table-hover"
                            :id="busquedaContenidos.tabla.ID"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"
                            data-maintain-selected="true"  
                            data-page-size = "5"
                            data-page-list="[5,10,20]"
                            data-click-to-select="false"
                            data-show-toggle="true"
                            data-show-pagination-switch="true"
                            data-search="true">
                            <thead class="thead-dark">
                                <tr>
                                    <th data-halign="center" data-width="6" data-align="center" data-checkbox="true"></th>
                                    <th data-halign="center" data-width="9" data-align="center" data-field="ContenidoDeIntreanetId" data-sortable="true">
                                        Id
                                    </th>
                                    <th data-events="operateEvents" data-halign="center" data-width="45" data-align="center" data-field="descripcion" data-sortable="true">
                                        Texto del contenido
                                    </th>
                                    <th data-halign="center" data-width="25" data-align="center" data-field="ultimaModificacion" data-sortable="true">
                                        Ultima de actaulizacion
                                    </th>
                                    <th data-events="operateEvents" data-width="15" :data-formatter="this.obtenerHTMLAcciones()" data-halign="center" data-align="center">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- FORMULARIO ALTA DE CONTENIDO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-alta-contenido-intranet">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario alta de contenidos</h5>
                        <button  id="btn-cerrar-modal-alta-contenido-intranet" @click="confirmarPerdidadaDeInformacionEnFormulario" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 1em 2.5em 1em 2.5em !important;">
                        <!-- PASOS -->
                        <div id="seccion-pasos-formulario" class="row mr-2 ml-2">
                            <div v-if="formularioAlta.PASOS.UNO.mostrar" 
                                @click="evtCambioDePaso({ paso: formularioAlta.PASOS.UNO })" 
                                :id="formularioAlta.PASOS.UNO.ID" 
                                :class="(formularioAlta.PASOS.DOS.mostrar) ? 'col-4 paso-formulario paso-activo' : 'col-6 paso-formulario paso-activo'">
                                <h5>Paso 1</h5>
                                <h6>Datos generales</h6>
                            </div>
                            <div v-if="formularioAlta.PASOS.DOS.mostrar"
                                @click="evtCambioDePaso({ paso: formularioAlta.PASOS.DOS })" 
                                :id="formularioAlta.PASOS.DOS.ID"
                                class="col-4 paso-formulario">
                                <h5>Paso 2</h5>
                                <h6>Archivos</h6>
                            </div>
                            <div v-if="formularioAlta.PASOS.TRES.mostrar" 
                                @click="evtCambioDePaso({ paso: formularioAlta.PASOS.TRES })" 
                                :id="formularioAlta.PASOS.TRES.ID" 
                                :class="(formularioAlta.PASOS.DOS.mostrar) ? 'col-4 paso-formulario' : 'col-6 paso-formulario'">
                                <h5>Paso {{ (formularioAlta.PASOS.DOS.mostrar) ? '3' : '2' }}</h5>
                                <h6>Fechas</h6>
                            </div>
                        </div>
                        <!-- SECCION CAMPOS GENERALES -->
                        <div v-show="formularioAlta.PASOS.UNO.activo" id="seccion-campos-generales" class="form-group seccion-formulario mt-3">
                            <div class="d-flex justify-content-center align-items-center mb-2">
                                <hr style="flex: 1; border: none; height: 1px; background: white; margin-right: 1em;">
                                    <div class="titulo-seccion-formulario">
                                        <h6>Datos contenido</h6>
                                    </div>
                                <hr style="flex: 1; border: none; height: 1px; background: white;  margin-left: 1em;">
                            </div>
                            <!-- TIPO DE CLINICA -->
                            <div v-if="existeFormulario && formulario.EsClinica" class="form-group">
                                <h6>Tipo de clínica (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.catalogoTiposClinicas.seleccionado)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.catalogoTiposClinicas.seleccionado)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C031TiposClinicasIntranet
                                    class="p-0 m-0 inhabilitado"
                                    v-on:valorParaElPadre="evtCambioTipoClinica" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="formularioAlta.catalogoTiposClinicas.id" 
                                    :parametros="formularioAlta.catalogoTiposClinicas.parametros" 
                                    :valorDefinido="formularioAlta.catalogoTiposClinicas.valorDefinido" 
                                    :key="formularioAlta.catalogoTiposClinicas.contRender + 'KEY-TIPOSCLINICAS-VADCITR'"></C031TiposClinicasIntranet>
                            </div>
                            <!-- TIPO DE DOCUMENTO -->
                            <div v-if="existeFormulario && formulario.DocumentoDeArea" class="form-group">
                                <h6>Tipo de documento (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.catalogoTiposDocumentos.seleccionado)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.catalogoTiposDocumentos.seleccionado)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C025ContenidosDeIntranet
                                    class="p-0 m-0"
                                    v-on:valorParaElPadre="evtCambioTipoDeDocumento" 
                                    v-on:terminoCargaDeContenidos="evtPuedeAgregarContenidosListaDeDocumentos"
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="formularioAlta.catalogoTiposDocumentos.id" 
                                    :parametros="formularioAlta.catalogoTiposDocumentos.parametros" 
                                    :valorDefinido="-1" 
                                    :textoDeSeleccion="'tipo de documento'"
                                    :key="formularioAlta.catalogoTiposDocumentos.contRender + 'KEY-TIPOSdocuemntos-VADCITR'"></C025ContenidosDeIntranet>
                            </div>
                            <!-- IMAGEN DE COMUNICADO -->
                            <div v-if="existeFormulario && formulario.Imagen" class="form-group">
                                <h6>Seleccione la imagen del comunicado (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.imagen.objeto)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.imagen.objeto)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="imagen_comunicado" class="form-control" v-on:change="evtSubidorDeImagen($event)" :accept="formularioAlta.imagen.EXTENSIONES_DE_ARCHIVOS" />
                            </div>
                            <!-- TITULO DEL COMUNICADO -->
                            <div v-if="existeFormulario && formulario.Titulo" class="form-group">
                                <h6>Titulo del comunicado (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.comunicado.titulo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.comunicado.titulo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.comunicado.titulo" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el titulo del comunicado" />
                            </div>
                            <!-- SUBTITULO DEL COMUNICADO -->
                            <div v-if="existeFormulario && formulario.Subtitulo" class="form-group">
                                <h6>Subtitulo del comunicado (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.comunicado.subtitulo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.comunicado.subtitulo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.comunicado.subtitulo" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el subtitulo del comunicado" />
                            </div>
                            <!-- FECHA DEL COMUNICADO -->
                            <div v-if="existeFormulario && formulario.Fecha" class="form-group">
                                <h6>Fecha del comunicado (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.comunicado.fecha)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.comunicado.fecha)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.comunicado.fecha" type="date" class="form-control" />
                            </div>
                            <!-- TITULO DE SESION -->
                            <div v-if="existeFormulario && formulario.TituloSesion" class="form-group">
                                <h6>Titulo de sesión (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.titulo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.titulo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.sesion.titulo" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el titulo de la sesión" />
                            </div>
                            <!-- FECHA DE SESION -->
                            <div v-if="existeFormulario && formulario.FechaDeSesion" class="form-group">
                                <h6>Fecha de sesión (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.fecha)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.fecha)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.sesion.fecha" type="date" class="form-control" />
                            </div>
                             <!-- REPRESENTANTE DE SESION -->
                            <div v-if="existeFormulario && formulario.TextoDeSesion" class="form-group">
                                <h6>Nombre del representante (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.persona)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.persona)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.sesion.persona" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el nombre del representante de la sesión" />
                            </div>
                            <!-- TEXTO DEL CONTENIDO -->
                            <div v-if="existeFormulario && formulario.TextoDelContenido" class="form-group">
                                <h6>Texto del contenido (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.textoDelContenido)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.textoDelContenido)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <!-- <input v-model="formularioAlta.textoDelContenido" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el texto del contenido" /> -->
                                <textarea  v-model="formularioAlta.textoDelContenido" type="text" id="texto-contenido" class="form-control" placeholder="Ingrese el texto del contenido" rows="4"/>
                            </div>
                            <!-- TEXTO DEL VINCULO -->
                            <div v-if="existeFormulario && formulario.TextoDelVinculo" class="form-group">
                                <h6>Texto del vinculo (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.textoDelVinculo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.textoDelVinculo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.textoDelVinculo" type="text" id="texto-vinculo" class="form-control" placeholder="Ingrese el texto del vinculo" />
                            </div>
                            <!-- SWITCH ELECCION DE TIPO DE ACCESO -->
                            <div v-show="mostrarSwitchDeTipoAcceso" class="form-group" style="margin-top: 3em;">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label :class="[(formularioAlta.accesoEsVinculo) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formularioAlta.accesoEsVinculo = true">
                                        <input type="radio" name="options" id="radioAccesoEsVinculo" autocomplete="off" checked>ACCESO DE CONTENIDO ES VINCULO
                                    </label>
                                    <label :class="[(!formularioAlta.accesoEsVinculo) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formularioAlta.accesoEsVinculo = false">
                                        <input type="radio" name="options" id="radioAccesoEsArchivo" autocomplete="off">ACCESO DE CONTENIDO ES ARCHIVO
                                    </label>
                                </div>
                            </div>
                            <!-- VINCULO -->
                            <div v-show="(existeFormulario && mostrarSwitchDeTipoAcceso) ? formularioAlta.accesoEsVinculo : existeFormulario && formulario.Vinculo" class="form-group">
                                <h6>Vinculo (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.vinculo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.vinculo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.vinculo" type="text" id="texto-vinculo" class="form-control" placeholder="Ingrese el vinculo" />
                            </div>
                            <!-- ARCHIVO DE CONTENIDO -->
                            <div v-show="(existeFormulario && mostrarSwitchDeTipoAcceso) ? !formularioAlta.accesoEsVinculo : existeFormulario && formulario.Archivo" class="form-group">
                                <h6>Seleccione el archivo de descarga (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.archivo.objeto)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.archivo.objeto)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="archivo_input_individual" class="form-control" 
                                    v-on:change="evtSubidorDeArchivo({ evento: $event, esPara: TIPO_SUBIDOR_ARCHIVOS.INDIVIDUAL })" 
                                    :accept="formularioAlta.EXTENSIONES_DE_ARCHIVOS" />
                            </div>
                        </div>
                        <!-- SECCION ARCHIVOS DE SESIONES PENALES -->
                        <div v-show="formularioAlta.PASOS.DOS.activo && existeFormulario && formulario.ListaDeArchivosSesion" id="seccion-archivos-sesiones" class="form-group seccion-formulario mt-3">
                            <div class="d-flex justify-content-center align-items-center">
                                <hr style="flex: 1; border: none; height: 1px; background: white; margin-right: 1em;">
                                    <div class="titulo-seccion-formulario">
                                        <h6>Archivos de sesión</h6>
                                    </div>
                                <hr style="flex: 1; border: none; height: 1px; background: white;  margin-left: 1em;">
                            </div>
                            <!-- ARCHIVO PARA ORDEN DEL DIA -->
                            <div class="form-group">
                                <h6>Orden del dia (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.ordenDelDia)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.ordenDelDia)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="archivo_input_ordenDelDia" class="form-control" 
                                    v-on:change="evtSubidorDeArchivo({ evento: $event, esPara: TIPO_SUBIDOR_ARCHIVOS.ORDEN_DEL_DIA })" 
                                    :accept="formularioAlta.EXTENSIONES_DE_ARCHIVOS" />
                            </div>
                            <!-- ARCHIVO PARA PONENCIA -->
                            <div class="form-group">
                                <h6>Ponencia (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.ponencia)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.ponencia)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="archivo_input_ponencia" class="form-control" 
                                    v-on:change="evtSubidorDeArchivo({ evento: $event, esPara: TIPO_SUBIDOR_ARCHIVOS.PONENCIA })" 
                                    :accept="formularioAlta.EXTENSIONES_DE_ARCHIVOS" />
                            </div>
                            <!-- ARCHIVO PARA ACTA DE SESION -->
                            <div class="form-group">
                                <h6>Acta de sesión (*)&nbsp;
                                    <i v-if="formularioAlta.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.sesion.actaDeSesion)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.sesion.actaDeSesion)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="archivo_input_actadesesion" class="form-control" 
                                    v-on:change="evtSubidorDeArchivo({ evento: $event, esPara: TIPO_SUBIDOR_ARCHIVOS.ACTA_DE_SESION })" 
                                    :accept="formularioAlta.EXTENSIONES_DE_ARCHIVOS" />
                            </div>
                        </div>
                        <!-- SECCION LISTADO DE ARCHIVOS -->
                        <div v-show="formularioAlta.PASOS.DOS.activo && existeFormulario && formulario.ListaDeArchivos" class="form-group seccion-lista-archivos seccion-formulario">
                            <div class="d-flex justify-content-center align-items-center">
                                <hr style="flex: 1; border: none; height: 1px; background: white; margin-right: 1em;">
                                    <div class="titulo-seccion-formulario">
                                        <h6>Archivos</h6>
                                    </div>
                                <hr style="flex: 1; border: none; height: 1px; background: white;  margin-left: 1em;">
                            </div>
                            <i v-if="formularioAlta.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.archivos.tabla.archivos)">
                                Debes ingresar al menos un archivo&nbsp;&nbsp;<i class="fas fa-times-circle text-danger font-size: 25px;"></i>
                            </i>
                            <!-- TEXTO DEL VINCULO ARCHIVO DE LISTA -->
                            <div class="form-group mt-4">
                                <h6>Texto del vinculo (*)&nbsp;
                                    <i v-if="formularioAlta.archivos.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.archivos.textoDelVinculo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.archivos.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.archivos.textoDelVinculo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formularioAlta.archivos.textoDelVinculo" type="text" id="texto-vinculo" class="form-control" placeholder="Ingrese el texto del vinculo" />
                            </div>
                            <!-- ARCHIVO DE LISTA -->
                            <div class="form-group">
                                <h6>Seleccione el archivo de descarga (*)&nbsp;
                                    <i v-if="formularioAlta.archivos.mostrarErrores && this.campoRequeridoEsValido(formularioAlta.archivos.tabla.archivoObj)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioAlta.archivos.mostrarErrores && !this.campoRequeridoEsValido(formularioAlta.archivos.tabla.archivoObj)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <div class="form-inline">
                                    <input type="file" id="archivo_input_lista" class="form-control col-10" 
                                        v-on:change="evtSubidorDeArchivo({ evento: $event, esPara: TIPO_SUBIDOR_ARCHIVOS.LISTA })" 
                                        :accept="formularioAlta.EXTENSIONES_DE_ARCHIVOS" />
                                    <button type="button" @click="evtAgregarArchivoALista" class="btn btn-sm btn-light ml-2" v-tooltip:right="'Agregar archivo'"><i class="fas fa-plus"></i></button>
                                </div>
                            </div>
                            <div class="contenedor-tabla-contenidos-intranet" style="padding: 0 !important; margin-top: 2em;">
                                <i>Lista de archivos agregados [{{ numeroDeArchivosEnLista }}]</i>
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="formularioAlta.archivos.tabla.ID"              
                                    data-toggle="table"
                                    data-pagination="true"
                                    data-undefined-text="Sin información"
                                    data-maintain-selected="true"  
                                    data-page-size = "1"
                                    data-page-list="[1,2,3]"
                                    data-click-to-select="false"
                                    data-show-toggle="false"
                                    data-search="false">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="10" data-align="center" data-checkbox="true"></th>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="id" data-sortable="true">
                                                #
                                            </th>
                                            <th data-halign="center" data-width="30" data-align="center" data-field="textoVinculoFormatoHTML" data-sortable="true">
                                                Texto del vinculo
                                            </th>
                                            <th data-halign="center" data-width="30" data-align="center" data-field="nombre" data-sortable="true">
                                                Archivo
                                            </th>
                                            <th data-events="operateEvents" data-width="20" :data-formatter="this.obtenerHTMLAccionesArchivos()" data-halign="center" data-align="center">
                                                Acciones
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <!-- FECHAS DE PUBLICACION -->
                        <div v-show="formularioAlta.PASOS.TRES.activo" id="seccion-fechas-publicacion" class="form-group mt-4 seccion-formulario">
                             <div class="d-flex justify-content-center align-items-center">
                                <hr style="flex: 1; border: none; height: 1px; background: white; margin-right: 1em;">
                                    <div class="titulo-seccion-formulario">
                                        <h6>Fechas de publicación</h6>
                                    </div>
                                <hr style="flex: 1; border: none; height: 1px; background: white;  margin-left: 1em;">
                            </div>
                            <div class="form-inline justify-content-between mt-4">
                                <div class="form-inline">
                                    <h6 class="pr-2">Inicio</h6>
                                    <datepicker :key="formularioAlta.fechas.inicio.KEY + formularioAlta.fechas.inicio.contRender" 
                                        :format="formularioAlta.fechas.DatePickerFormato"  
                                        :highlighted="formularioAlta.fechas.inicio.marcarFechas"
                                        :disabled-dates="formularioAlta.fechas.inicio.fechasDeshabilitadas" 
                                        v-model="formularioAlta.fechas.inicio.fecha"
                                        @selected="evtSeleccionDeFechaDtPk"  
                                        :value="formularioAlta.fechas.inicio.fechaDefault" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt" 
                                        name="fecha" 
                                        :language="formularioAlta.fechas.lenguaje"></datepicker>
                                </div>
                                <div class="form-inline">
                                    <h6 class="pr-2">Fin </h6>
                                    <datepicker :key="formularioAlta.fechas.fin.KEY + formularioAlta.fechas.fin.contRender" 
                                        :format="formularioAlta.fechas.DatePickerFormato"  
                                        :highlighted="formularioAlta.fechas.fin.marcarFechas"
                                        :disabled-dates="formularioAlta.fechas.fin.fechasDeshabilitadas" 
                                        v-model="formularioAlta.fechas.fin.fecha"
                                        @selected="evtSeleccionDeFechaDtPk"  
                                        :value="formularioAlta.fechas.fin.fechaDefault" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt"  
                                        :class="{'texto-negro': true}" name="fecha" 
                                        :language="formularioAlta.fechas.lenguaje"></datepicker>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="modal-footer" style="padding: 0.8em 1em 0.8em 1em !important;">
                        <div id="seccion-acciones" class="d-flex justify-content-end">
                            <button type="button" @click="iniciarProcesoDeGuardado" class="btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL COFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo-adminContIntranet">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalInformativo.titulo }}</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>{{ modalInformativo.mensaje }}</h6>
                            <!-- <div class="form-inline justify-content-end">
                                <button type="button" class="btn btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button>
                                <button type="button" class="btn btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                            </div> -->
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL PARA ORDENAMIENTO DE CONTENIDOS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-ordenamiento-contenidosIntranet">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordenamiento de menús</h5>
                        <button  id="btn-cerrar-modal-ordenamiento-contenidosIntranet" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div v-if="this.campoRequeridoEsValido(busquedaContenidos.contenidos.ordenamiento.listaAordenar)">
                            <div id="instrucciones-ordenamiento" class="form-inline">
                                <i class="fas fa-info-circle"></i>&nbsp;
                                <i>Selecciona y desplaza los contenidos para cambiar el orden.</i>
                            </div>
                            <div id="lista-ordenamiento-contenidos" class="mt-2">
                                <ClistaOrdenable
                                    :elementos="busquedaContenidos.contenidos.ordenamiento.listaAordenar"
                                    :referenciasElemento="busquedaContenidos.contenidos.ordenamiento.REFERENCIAS"
                                    :informacionAmostrar="busquedaContenidos.contenidos.ordenamiento.CAMPOS"
                                    v-on:ModificacionEnListaDeElementos="evtOrdenDeContenidoSeModifico"></ClistaOrdenable>
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                                <button type="button" 
                                    @click="iniciarprocesoCambioDeOrdenContenidos({ tipoOrdenamiento: busquedaContenidos.contenidos.ordenamiento.TIPO.ALFABETICO })" 
                                    class="btn btn-sm btn-light mr-2"><i class="fas fa-sort-alpha-down"></i>&nbsp;Ordenar alfabéticamente</button>
                                <button type="button" 
                                    @click="iniciarprocesoCambioDeOrdenContenidos({ tipoOrdenamiento: busquedaContenidos.contenidos.ordenamiento.TIPO.DESPLAZAMIENTO })" 
                                    class="btn btn-sm btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CFiltrosDeContenidos from '@/components/SICPO/Intranet/Contenidos/CFiltrosDeBusqueda.vue';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import ClistaOrdenable from '@/components/SICPO/Comun/ClistaOrdenable.vue'

Date.prototype.agregarDias = function(dias) {
    var fecha = new Date(this.valueOf());
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
}

export default {
    components: {
        C031TiposClinicasIntranet : catalogos.SICPO.C031TiposClinicasIntranet,
        C025ContenidosDeIntranet : catalogos.SICPO.C025ContenidosDeIntranet,
        CFiltrosDeContenidos: CFiltrosDeContenidos,
        Datepicker,
        ClistaOrdenable
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            enumeraciones,
            modalInformativo: {
                titulo: 'Mensaje del sistema',
                mensaje: '',
                funcionConfirmar: () => {},
                funcionCancelar: () => {}
            },
            formularioAlta: {
                PASOS: {
                    UNO:  { LLAVE: 1, ID: 'paso-formulario-inp-uno',  activo: true, mostrar: true,  descripcion: 'Datos generales' },
                    DOS:  { LLAVE: 2, ID: 'paso-formulario-inp-dos',  activo: false, mostrar: false, descripcion: 'Archivos' },
                    TRES: { LLAVE: 3, ID: 'paso-formulario-inp-tres', activo: false, mostrar: true,  descripcion: 'Fechas' }
                },
                esEdicion: false,
                EXTENSIONES_DE_ARCHIVOS: '.PDF, .DOC, .DOCX, .PNG, .JPG, .JPEG, .XLS',
                textoDelContenido: null,
                textoDelVinculo: null,
                vinculo: null,
                mostrarErrores: false,
                fechas: {
                    FORMATO: 'YYYY-MM-DD',
                    DatePickerFormato: 'yyyy-MM-dd',
                    lenguaje:{
                        language: 'es',
                        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                        monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                        days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                        rtl: false,
                        ymd: 'yyyy-MM-dd',
                        yearSuffix: ''
                    },
                    inicio: {
                        KEY: 'DTPCKinicioVEDC',
                        contRender: 0,
                        fecha: new Date(),
                        fechaSeleccionada: 0,
                        fechaDefault: new Date(),
                        marcarFechas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_FINAL = moment(this.formularioAlta.fechas.fin.fecha).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formularioAlta.fechas.inicio.fecha).format('YYYY-MM-DD');
                                if(this.formularioAlta.esUrgente) {
                                    const DIA_VALIDO = (DIA_SELECCIONADO == FECHA_INICIAL); 
                                    return DIA_VALIDO;
                                }
                                else {
                                    const RANGO_DIAS_VALIDO = (DIA_SELECCIONADO >= FECHA_INICIAL && DIA_SELECCIONADO <= FECHA_FINAL);
                                    return RANGO_DIAS_VALIDO;
                                }
                            },
                            includeDisabled: false
                        },
                        fechasDeshabilitadas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_ACTUAL = moment().format('YYYY-MM-DD');
                                const DIA_VALIDO = (DIA_SELECCIONADO < FECHA_ACTUAL);
                                return DIA_VALIDO; 
                            }
                        }
                    },
                    fin: {
                        KEY: 'DTPCKfinVEDC',
                        contRender: 0,
                        fecha: new Date().agregarDias(150),
                        fechaSeleccionada: 0,
                        fechaDefault: new Date(),
                        marcarFechas: { 
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_FINAL = moment(this.formularioAlta.fechas.fin.fecha).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formularioAlta.fechas.inicio.fecha).format('YYYY-MM-DD');
                                const DIAS_VALIDOS = (DIA_SELECCIONADO >= FECHA_INICIAL && DIA_SELECCIONADO <= FECHA_FINAL); 
                                return DIAS_VALIDOS;
                            },
                            includeDisabled: false
                        },
                        fechasDeshabilitadas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formularioAlta.fechas.inicio.fecha).format('YYYY-MM-DD');
                                const DIA_VALIDO = (DIA_SELECCIONADO < FECHA_INICIAL);
                                return DIA_VALIDO;
                            }
                        }
                    }
                },
                archivo: {
                    objeto: null,
                    utilizoSubidor: false
                },
                archivos: {
                    mostrarErrores: false,
                    textoDelVinculo: null,
                    lista: [],
                    tabla: {
                        ID: 'IDTablaDeArchivosFormulario',
                        archivoObj: null,
                        archivos: [],
                        contadorDeArchivos: 0
                    }
                },
                // comunicados
                imagen: {
                    EXTENSIONES_DE_ARCHIVOS: '.PNG, .JPG, .JPEG',
                    objeto: null,
                    REFERENCIA: 'ImagenDeComunicado'
                },
                comunicado: {
                    titulo: null,
                    subtitulo: null,
                    fecha: null
                },
                // clinicas
                sesion: {
                    titulo: null,
                    persona: null,
                    fecha: null,
                    ordenDelDia: null,
                    ponencia: null,
                    actaDeSesion: null
                },
                catalogoTiposClinicas: {
                    id: 'catalogoTiposDeClinicasIntranet',
                    CLINICA_PENAL: 7,
                    parametros: {
                        Nombre: null,
                        Descripcion: null,
                        ConInactivos: false,
                        ConContenidos: false
                    },
                    valorDefinido: -1,
                    contRender: 0,
                    seleccionado: null,
                    // RELACION DE ID ENTRE AREAS DE INTRANET TIPO CLINICA Y CATALOGO DE CLINICAS
                    CLINICAS: { 15: 1, 16: 3, 17: 5, 18: 7 }
                },
                catalogoTiposDocumentos: {
                    id: 'catalogoTiposDeDocumentosIntranet',
                    parametros: {
                        AreaDeIntranetId: null,
                        SeccionId: 28, // Seccion para los tipos de documentos
                        EstatusDelContenidoId: null,
                        TextoDelContenido: null,
                        TextoDelVinculo: null,
                        Orden: null,
                        FechaDePublicacion: null,
                        FechaFinalDePublicacion: null,
                        FechaDeRegistro: null,
                        FechaDeModificacion: null,
                        ConInactivos: null,
                        PorOrdenDelContenido: null
                    },
                    valorDefinido: -1,
                    contRender: 0,
                    seleccionado: null
                },
                accesoEsVinculo: false
            },
            busquedaContenidos: {
                filtros: {
                    elementos: null,
                    KEY: 'FBusquedaContenidosVADMINCINT',
                    contRender: 0,
                    parametros: null
                },
                contenidos: {
                    lista: [],
                    listaBD:[],
                    seleccionado: null,
                    seleccionados: [],
                    ordenamiento: {
                        listaAordenar: [],
                        listaNuevoOrden: [],
                        REFERENCIAS: { folio: 'ContenidoDeIntreanetId', orden: 'Orden',fechaPublicacion: 'FechaFinalDeModificacion', descripcion: 'descripcion' },
                        CAMPOS: { folio: true, fechaPublicacion: true, descripcion: true },
                        TIPO: { DESPLAZAMIENTO: 1, ALFABETICO: 2 }
                    }
                },
                tabla: {
                    ID: 'TablaDeContenidosIntranetVACITR',
                    mostrarAyuda: true
                },
            },
            FORMULARIOS: {
                ALTA: 1,
                EDICION: 2
            },
            TIPO_SUBIDOR_ARCHIVOS: {
                INDIVIDUAL: 1,
                LISTA: 2,
                ORDEN_DEL_DIA: 3,
                PONENCIA: 4,
                ACTA_DE_SESION: 5
            }
        }
    },
    methods: {
        // FUNCIONES
        iniciarprocesoCambioDeOrdenContenidos: async function({ tipoOrdenamiento }) { 
            const { DESPLAZAMIENTO } = this.busquedaContenidos.contenidos.ordenamiento.TIPO;
            let { listaNuevoOrden } = this.busquedaContenidos.contenidos.ordenamiento;
            if(this.campoRequeridoEsValido(listaNuevoOrden)) {
                const PETICION_API = (tipoOrdenamiento == DESPLAZAMIENTO) 
                    ? await Promise.resolve(this.crearPeticionModificacionDeOrdenamiento())
                    : { SeccionId: this.busquedaContenidos.filtros.parametros.seccionId, EsPrueba: false };
                $("#modal-ordenamiento-contenidosIntranet").modal('hide');
                await Promise.resolve(this.cambiarOrdenDeContenidosBD({ peticion: PETICION_API, ordenarPor: tipoOrdenamiento }));
                await Promise.resolve(this.iniciarProcesoBusquedaDeContenidos(this.busquedaContenidos.filtros.parametros));
            }
        },
        crearPeticionModificacionDeOrdenamiento: async function() {
            let peticion = {};
            let contenidos = this.busquedaContenidos.contenidos.ordenamiento.listaNuevoOrden.map(cnord => { 
                let contenidoObj = {...cnord};
                contenidoObj.FechaDePublicacion = moment();
                contenidoObj.FechaDeRegistro = moment();
                contenidoObj.FechaFinalDeModificacion = moment();
                delete contenidoObj['descripcion']; 
                return contenidoObj
             });
             peticion.ContenidosDeIntranet = contenidos;
             peticion.EsPrueba = false;
             return peticion;
        },
        cambiarOrdenDeContenidosBD: async function({ peticion, ordenarPor, conCargandoInformacion = true, conMensaje = true }) {
            const { DESPLAZAMIENTO } = this.busquedaContenidos.contenidos.ordenamiento.TIPO;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_ACTUALIZAR = (ordenarPor == DESPLAZAMIENTO) 
                    ? api.SICPO.sistema.intranet.administracionDeContenidos.ModificarOrdenamientoContenidosDeIntranetAdministracion 
                    : api.SICPO.sistema.intranet.administracionDeContenidos.OrdenamientoAlfabeticoContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_ACTUALIZAR;
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-ordenamiento-contenidosIntranet").modal('show');
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    if(conMensaje)
                        comun.mensajeDeAlerta(Satisfactorio, null, null);
                }
            }
            catch(excepcion) {
                $("#modal-ordenamiento-contenidosIntranet").modal('show');
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        }, 
        ocultarTooltip: function() {
            $(".tooltip").tooltip("hide");
            this.$nextTick(() => { 
               $(".tooltip").tooltip("hide");
            });
        },
        confirmarCambioDeEstatusAContenidos: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `Al cambiar a inactivos los contenidos seleccionados se dejaran de mostrar en intranet\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                    this.iniciarProcesoCambioEstatusDeContenido();
                },
                funcionCancelar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                }
            }
            $("#modal-informativo-adminContIntranet").modal('show');
        },
        iniciarProcesoCambioEstatusDeContenido: async function() {
            const PETICION_API = await Promise.resolve(this.crearPeticionCambioEstatusDeContenido());
            await Promise.resolve(this.cambiarEstatusDeContenidoBD({ peticion: PETICION_API }));
            await Promise.resolve(this.iniciarProcesoBusquedaDeContenidos(this.busquedaContenidos.filtros.parametros));
            this.$nextTick(() => {
                const MENSAJE_SATISFACTORIO = (PETICION_API.ContenidosDeIntranet.length > 0) ? 
                    'Los contenidos seleccionados se cambiaron a inactivos de manera correcta' : 'El contenido seleccionado se cambio a inactivo de manera correcta';
                this.busquedaContenidos.contenidos.seleccionados = [];
                $("#" + this.busquedaContenidos.tabla.ID).bootstrapTable('uncheckAll');
                comun.mensajeDeAlerta(MENSAJE_SATISFACTORIO);
            });
        },
        crearPeticionCambioEstatusDeContenido: async function() {
            let peticion = {};
            let contenidos = [];
            if(this.campoRequeridoEsValido(this.contenidosSeleccionados)) {
                const ESTATUS_INACTIVO = 4;
                contenidos = this.contenidosSeleccionados.map(cs => {
                    let contenidoObj = {...cs};
                    contenidoObj.EstatusDelContenido = { TipoEstatusDelContenidoId: ESTATUS_INACTIVO, Activo: true };
                    return contenidoObj;
                });
            }
            peticion.ContenidosDeIntranet = contenidos;
            return peticion;
        },
        cambiarEstatusDeContenidoBD: async function({ peticion, conCargandoInformacion = true, conMensaje = false }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_ACTUALIZAR = api.SICPO.sistema.intranet.administracionDeContenidos.CambioDeEstatusContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_ACTUALIZAR;
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    if(conMensaje)
                        comun.mensajeDeAlerta(Satisfactorio, null, null);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        iniciarProcesoBusquedaDeContenidos: async function(parametros) {
            const PETICION_API = { AreaDeIntranetId: parametros.areaIntranetId, SeccionId: parametros.seccionId, ConInactivos: false };
            await Promise.resolve(this.obtenerContenidosBD({ peticion: PETICION_API }));
        },
        confirmarActualizacionDeBusqueda: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `Se agrego un nuevo contenido deseas cargar la lista de contenidos\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                    this.iniciarProcesoBusquedaDeContenidos(this.busquedaContenidos.filtros.parametros);
                },
                funcionCancelar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                }
            }
            $("#modal-informativo-adminContIntranet").modal('show');
        },
        obtenerContenidosBD: async function({ peticion, conCargandoInformacion = true, conMensaje = false }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.administracionDeContenidos.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Satisfactorio, ContenidosDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    this.busquedaContenidos.contenidos.listaBD = (this.campoRequeridoEsValido(ContenidosDeIntranet)) ? ContenidosDeIntranet : [];
                    await Promise.resolve(this.inicializarTabla({ elementos: this.busquedaContenidos.contenidos.listaBD }));
                    comun.SeEstaCargandoInformacion(false);
                    if(conMensaje)
                        comun.mensajeDeAlerta(Satisfactorio, null, null);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        inicializarTabla: async function({ elementos }) { 
            this.busquedaContenidos.contenidos.lista = await Promise.resolve(this.darFormatoObjetosDeArchivos({ elementos: elementos }));
            this.$nextTick(() => {
                $("#" + this.busquedaContenidos.tabla.ID).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $("#" + this.busquedaContenidos.tabla.ID).bootstrapTable({  data: this.busquedaContenidos.contenidos.lista });      
                $("#" + this.busquedaContenidos.tabla.ID).bootstrapTable('load', this.busquedaContenidos.contenidos.lista ); 
                $("#" + this.busquedaContenidos.tabla.ID).on('check.bs.table',(e, row) => {
                    this.evtContenidoSeleccionado({ contenido: row });
                });
                $("#" + this.busquedaContenidos.tabla.ID).on('uncheck.bs.table',(e, row) => {
                    const TIPO_CHECK = 'UNO';
                    this.evtRemoverContenidosDeListaSeleccionados({ tipoCheck: TIPO_CHECK, contenidos: row });
                });
                $("#" + this.busquedaContenidos.tabla.ID).on('check-all.bs.table',(e, rows) => {
                    this.evtSeleccionarTodosLosContenidos({ contenidos: rows });
                });
                $("#" + this.busquedaContenidos.tabla.ID).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    const TIPO_CHECK = 'MUCHOS';
                    this.evtRemoverContenidosDeListaSeleccionados({ tipoCheck: TIPO_CHECK, contenidos: rowsBefore });
                });
            });
        },
        evtContenidoSeleccionado: function({ contenido }) {
            if(!this.busquedaContenidos.contenidos.seleccionados.some(csel => csel.ContenidoDeIntreanetId == contenido.ContenidoDeIntreanetId)) {
                const CONTENIDO_ESTRUCTURA_BD = this.busquedaContenidos.contenidos.listaBD.find(cbd => cbd.ContenidoDeIntreanetId == contenido.ContenidoDeIntreanetId);
                this.busquedaContenidos.contenidos.seleccionados.push(CONTENIDO_ESTRUCTURA_BD);
            }
        },
        evtSeleccionarTodosLosContenidos: function({ contenidos }) {
            this.busquedaContenidos.contenidos.seleccionados = this.busquedaContenidos.contenidos.listaBD.filter(cBD => contenidos.some(ct => ct.ContenidoDeIntreanetId == cBD.ContenidoDeIntreanetId));
        },
        evtRemoverContenidosDeListaSeleccionados: function({ tipoCheck, contenidos }) {
            switch(tipoCheck) {
                case 'UNO':
                    this.busquedaContenidos.contenidos.seleccionados = this.busquedaContenidos.contenidos.seleccionados.filter(csel => csel.ContenidoDeIntreanetId != contenidos.ContenidoDeIntreanetId);
                    break;
                case 'MUCHOS':
                    // se remueven la paginacion de contenidos seleccionados
                    this.busquedaContenidos.contenidos.seleccionados = this.busquedaContenidos.contenidos.seleccionados.filter(csel => {
                        return !contenidos.some(crsel => {
                            return csel.ContenidoDeIntreanetId == crsel.ContenidoDeIntreanetId;
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        darFormatoObjetosDeArchivos: async function({ elementos }) {
            let contenidosFormatoTabla = [];
            if(this.campoRequeridoEsValido(elementos)) {
                /* this.busquedaContenidos.contenidos.lista = elementos.map(cBD => { debugger */
                contenidosFormatoTabla = elementos.map(cBD => {
                    let contenidoObj = {...cBD};

                    // se obtiene el texto segun el tipo de contenido
                    contenidoObj.descripcion = cBD.TextoDelContenido;
                    if(this.campoRequeridoEsValido(cBD.SesionDeClinicaIntranet))
                        contenidoObj.descripcion = cBD.SesionDeClinicaIntranet.Titulo;
                    if(this.campoRequeridoEsValido(cBD.Comunicado))
                        contenidoObj.descripcion = cBD.Comunicado.Titulo;

                    contenidoObj.ultimaModificacion = this.obtenrDatosDeUltimaModificacion({ contenido: cBD });
                    return contenidoObj;
                })
            }
            return contenidosFormatoTabla;
        },
        obtenrDatosDeUltimaModificacion: function({ contenido }) { 
            const FORMATO_FECHAS = 'YYYY-MM-DD';
            let datosDeUltimaModificacion = '';
            const { UsuarioQueModifico, UsuarioQueRegistro, FechaFinalDeModificacion, FechaDeRegistro } = contenido;
            if(this.campoRequeridoEsValido(UsuarioQueModifico) && this.campoRequeridoEsValido(FechaFinalDeModificacion)) {
                let DATOS_NOMBRE = [UsuarioQueModifico.Nombre, UsuarioQueModifico.ApellidoPaterno, UsuarioQueModifico.ApellidoMaterno]
                const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                datosDeUltimaModificacion += `<strong>${ NOMBRE_COMPLETO.trim() }</strong>`;
                datosDeUltimaModificacion += '<br>';
                datosDeUltimaModificacion += `[${ moment(FechaFinalDeModificacion).format(FORMATO_FECHAS) }]`;
            }
            else if(this.campoRequeridoEsValido(UsuarioQueRegistro) && this.campoRequeridoEsValido(FechaDeRegistro)){
                let DATOS_NOMBRE = [UsuarioQueRegistro.Nombre, UsuarioQueRegistro.ApellidoPaterno, UsuarioQueRegistro.ApellidoMaterno]
                const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                datosDeUltimaModificacion += `<strong>${ NOMBRE_COMPLETO.trim() }</strong>`
                datosDeUltimaModificacion += '<br>';
                datosDeUltimaModificacion += `[${ moment(FechaDeRegistro).format(FORMATO_FECHAS) }]`;
            }
            else {
                datosDeUltimaModificacion += `sin datos`;
            }
            return datosDeUltimaModificacion;
        },
        sePuedeIniciarProcesoDeGuardado: function() { debugger
            let formularioTerminado = true;
            const { textoDelContenido, textoDelVinculo, fechas, vinculo, imagen, comunicado, sesion, archivo, archivos, catalogoTiposDocumentos, accesoEsVinculo } = this.formularioAlta;
            const  { inicio, fin } = fechas;
            // se crea la relacion de los campos del formulario y sus valores
            const CAMPOS_FORMULARIO = [
                { llave: 'EsClinica', valor: this.formularioAlta.catalogoTiposClinicas.valorDefinido },
                { llave: 'TextoDelContenido', valor: textoDelContenido },
                { llave: 'TextoDelVinculo', valor: textoDelVinculo },
                { llave: 'Vinculo', valor: vinculo },
                { llave: 'Archivo', valor: archivo.objeto },
                { llave: 'Imagen', valor: imagen.objeto },
                { llave: 'Titulo', valor: comunicado.titulo },
                { llave: 'Subtitulo', valor: comunicado.subtitulo },
                { llave: 'Fecha', valor: comunicado.fecha },
                { llave: 'TituloSesion', valor: sesion.titulo },
                { llave: 'TextoDeSesion', valor: sesion.persona },
                { llave: 'FechaDeSesion', valor: sesion.fecha },
                { llave: 'ListaDeArchivos', valor: archivos.tabla.archivos },
                /* { llave: 'DocumentoDeArea', valor: catalogoTiposDocumentos.seleccionado} */
            ];
            // se valida cada uno de los campos requeridos en el formulario
            const FECHAS_PUBLICACION_VALIDAS = (this.campoRequeridoEsValido(inicio.fecha) && this.campoRequeridoEsValido(fin.fecha));
            const ARCHIVOS_SESION_COMPLETOS = (this.campoRequeridoEsValido(sesion.ordenDelDia) && this.campoRequeridoEsValido(sesion.ponencia) && this.campoRequeridoEsValido(sesion.actaDeSesion));

            let formularioTemporal = { ...this.busquedaContenidos.filtros.elementos };
            if(this.mostrarSwitchDeTipoAcceso) {
                formularioTemporal['Vinculo'] = (accesoEsVinculo);
                formularioTemporal['Archivo'] = (!accesoEsVinculo);
            }

            for(var referenciaInput in formularioTemporal) {
                let inputActivoEnFormulario = formularioTemporal[referenciaInput];
                if(inputActivoEnFormulario) {
                    let input = CAMPOS_FORMULARIO.find(cf => cf.llave == referenciaInput);
                    if(this.campoRequeridoEsValido(input) && !this.campoRequeridoEsValido(input.valor)) {
                        formularioTerminado = false;
                        break;
                    }
                }
            }

            if(formularioTemporal.ListaDeArchivosSesion)
                formularioTerminado = (formularioTerminado && ARCHIVOS_SESION_COMPLETOS)

            return (formularioTerminado && FECHAS_PUBLICACION_VALIDAS);
        },
        iniciarProcesoDeGuardado: async function() { 
            if(this.sePuedeIniciarProcesoDeGuardado()) {
                this.formularioAlta.mostrarErrores = false;
                const PETICION_API = await Promise.resolve(this.crearPeticionNuevoContenido());
                // Eliminar despues de estapa de desarrollo
                for (var pair of PETICION_API.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                $("#modal-alta-contenido-intranet").modal('hide');
                await Promise.resolve(this.guardarNuevoContenidoBD({ peticion: PETICION_API }));
            }
            else {
                this.formularioAlta.mostrarErrores = true;
            }
        },
        guardarNuevoContenidoBD: async function({ peticion, conCargaDeContenidos = true }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDeContenidos.GuardarContenidoDeIntranetAdministracion;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_PETICION = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-alta-contenido-intranet").modal('show');
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    this.limpiarFormulario({ conSeccionFechas: true, conSeccionArchivos: true, conSeccionComunicados: true, conSeccionClinicas: true });
                    if(conCargaDeContenidos) 
                        this.confirmarActualizacionDeBusqueda();
                    else 
                        comun.mensajeDeAlerta(Satisfactorio, null, null);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                $("#modal-alta-contenido-intranet").modal('show');
            }
        },
        crearPeticionNuevoContenido: async function() { 
            let peticion = new FormData();
            // datos del formulario
            let { textoDelContenido, textoDelVinculo, fechas, vinculo, imagen, comunicado, sesion, catalogoTiposClinicas, catalogoTiposDocumentos, accesoEsVinculo } = this.formularioAlta;
            let { inicio, fin } = fechas;
            // datos filtros de busqueda
            let { parametros } = this.busquedaContenidos.filtros;
            // se llenan los datos generales del contenido
            let contenidoObj = {};
            contenidoObj.ContenidoDeIntreanetId = -1;
            contenidoObj.TextoDelContenido = textoDelContenido;
            contenidoObj.TextoDelVinculo = textoDelVinculo;
            contenidoObj.Orden = null;
            contenidoObj.FechaDePublicacion = inicio.fecha;
            contenidoObj.FechaFinalDePublicacion = fin.fecha;
            contenidoObj.FechaDeRegistro = moment();
            contenidoObj.Vinculo = (this.mostrarSwitchDeTipoAcceso) 
                ? (accesoEsVinculo) ? vinculo : null 
                : vinculo;
            contenidoObj.FechaFinalDeModificacion = null;
            // se crea objeto de la secciona a la que pertenece 
            let seccionALaQuePerteneceObj = {
                SeccionDeIntranetId: parametros.seccionId,
                // propiedades no relevantes solo se asignan para prevenir algun error en la peticion ya que no son nullables
                MostrarNombreDeLaSeccion: false,
                EnEdicion: false,
                Activo: false,
                PermiteSubirContenido: false
            };
            contenidoObj.SeccionALaQuePertenezco = seccionALaQuePerteneceObj;
            // se crea objeto para el estatus del contenido
            const ESTATUS_ACEPTADO = 2;
            let estatusDeContenidoObj = {
                TipoEstatusDelContenidoId: ESTATUS_ACEPTADO,
                // propiedades no relevantes solo se asignan para prevenir algun error en la peticion ya que no son nullables
                Activo: false
            };
            contenidoObj.EstatusDelContenido = estatusDeContenidoObj;
            // se crea el objeto del area de intranet a la que pertene el contenido
            if(this.campoRequeridoEsValido(parametros.areaIntranetId)) {
                let areaDeIntranetObj = {
                    AreaDeIntranetId: parametros.areaIntranetId,
                };
                contenidoObj.AreaDeIntranetALaQuePertenece = areaDeIntranetObj;
            }
            // se crea el comunicado del contenido en caso de ser comunicado
            if(this.formulario.EsComunicado) {
                let comunicadoObj = {
                    RutaDeImagen: imagen.REFERENCIA,
                    Titulo: comunicado.titulo,
                    SubTitulo: comunicado.subtitulo,
                    Fecha: comunicado.fecha
                }
                contenidoObj.Comunicado = comunicadoObj;
                peticion.append(imagen.REFERENCIA,imagen.objeto); 
            }
            // se crea el sesion del contenido en caso de ser una clinica penal
            if(this.formulario.EsSesion) {
                let sesionObj = {
                    Titulo: sesion.titulo,
                    TextoDeSesion: sesion.persona,
                    Fecha: sesion.fecha
                }
                contenidoObj.SesionDeClinicaIntranet = sesionObj;
            }
            // se crea la clinica del contenido en caso de ser una clinica
            if(this.formulario.EsClinica) {
                let tipoClinicaObj = {
                    TipoDeClinicaId: catalogoTiposClinicas.valorDefinido,
                    Activo: true
                }
                contenidoObj.TipoDeClinica = tipoClinicaObj;
            }
            // se crea contenido al que pertenece
            if(this.formulario.DocumentoDeArea) {
                let contenidoAlQuePerteneceObj = {
                    ContenidoDeIntreanetId: catalogoTiposDocumentos.seleccionado.ContenidoDeIntreanetId,
                    // solo se asignan estos valores en fechas para evitar error de coneversion de peticion, no afectan al contenido original
                    FechaDePublicacion: moment(),
                    FechaDeRegistro: moment()
                }
                contenidoObj.ContenidoAlQuePertenece = contenidoAlQuePerteneceObj;
            }
            // se crea la lista de archivos del contenido
            contenidoObj.ArchivosDeContenidoIntranet = (this.mostrarSwitchDeTipoAcceso) 
                ? (!accesoEsVinculo) ? await Promise.resolve(this.obtenerArchivosConFormato({ esSesion: this.formulario.EsSesion })) : []
                : await Promise.resolve(this.obtenerArchivosConFormato({ esSesion: this.formulario.EsSesion }));
            // se agregan los archivos a a la peticion
            if(contenidoObj.ArchivosDeContenidoIntranet.length > 0) {
                contenidoObj.ArchivosDeContenidoIntranet.forEach(archivoDeContenido => {
                    peticion.append(archivoDeContenido.Ruta,archivoDeContenido.file);
                    delete archivoDeContenido['file'];
                })
            }
            console.log('objetoDePeticion::',contenidoObj);
            // se llenan las propiedas independientes de la peticion
            peticion.append('EsPrueba',false); 
            peticion.append('Contenido',JSON.stringify(contenidoObj));
            peticion.append('PaginaId',parametros.paginaId); 
            peticion.append('SeccionId',parametros.seccionId); 
            peticion.append('EsComunicado',this.formulario.EsComunicado); 
            peticion.append('EsSesion',this.formulario.EsSesion);
            return peticion;
        },
        obtenerArchivosConFormato: async function({ esSesion }) {
            let archivosConFormato = [];
            let { archivo, archivos, sesion } = this.formularioAlta;
            const ARCHIVOS_SESION_COMPLETOS = (this.campoRequeridoEsValido(sesion.ordenDelDia) && this.campoRequeridoEsValido(sesion.ponencia) && this.campoRequeridoEsValido(sesion.actaDeSesion));
            const INICIAR_CONVERSION = (esSesion) ? this.campoRequeridoEsValido(ARCHIVOS_SESION_COMPLETOS) : 
                (this.formulario.ListaDeArchivos) ? this.campoRequeridoEsValido(archivos.tabla.archivos) : this.campoRequeridoEsValido(archivo.objeto);
            if(INICIAR_CONVERSION) {
                if(esSesion) {
                    const ARCHIVOS_DE_SESION = [
                        { llave: 'ordenDelDia', archivo: sesion.ordenDelDia, ref: 'ARCHIVO_ORENDEN_DEL_DIA', textoVinculo: 'Orden del día' }, 
                        { llave: 'ponencia', archivo: sesion.ponencia, ref: 'ARCHIVO_PONENCIA', textoVinculo: 'Ponencia' }, 
                        { llave: 'actaDeSesion', archivo: sesion.actaDeSesion, ref: 'ARCHIVO_ACTA_DE_SESION', textoVinculo: 'Acta de la sesión.' }]

                    archivosConFormato = ARCHIVOS_DE_SESION.map(at => {
                        let archivoObj = {};
                        archivoObj.ArchivoDeContenidoIntranetId = -1;
                        archivoObj.NombreBase = at.archivo.name;
                        archivoObj.NombreEnServidor = at.archivo.name;
                        archivoObj.Ruta = at.ref;
                        archivoObj.FechaDeRegistro = moment();
                        archivoObj.Activo = true;
                        archivoObj.TextoDelVinculo = at.textoVinculo;
                        archivoObj.MostrarEnVisor = false;
                        archivoObj.file = at.archivo;
                        return archivoObj;
                    });
                }
                else if(this.formulario.ListaDeArchivos) {
                    archivosConFormato = archivos.tabla.archivos.map(at => {
                        let archivoObj = {};
                        archivoObj.ArchivoDeContenidoIntranetId = -1;
                        archivoObj.NombreBase = at.nombre;
                        archivoObj.NombreEnServidor = at.nombre;
                        archivoObj.Ruta = at.referencia;
                        archivoObj.FechaDeRegistro = moment();
                        archivoObj.Activo = true;
                        archivoObj.TextoDelVinculo = at.textoVinculo;
                        archivoObj.MostrarEnVisor = false;
                        archivoObj.file = at.file;
                        return archivoObj;
                    });
                }
                else {
                    archivosConFormato.push({
                        ArchivoDeContenidoIntranetId: -1,
                        NombreBase: archivo.objeto.name,
                        NombreEnServidor: archivo.objeto.name,
                        Ruta: `ARCHIVO-1`,
                        FechaDeRegistro: moment(),
                        Activo: true,
                        TextoDelVinculo: null,
                        MostrarEnVisor: false,
                        file: archivo.objeto
                    })
                }
            }
            return archivosConFormato;
        },
        removerArchivoDeLista: function({ archivo }) {
            $("#" + this.formularioAlta.archivos.tabla.ID).bootstrapTable('remove', {
                field: 'id',
                values: [archivo.id]
            });
        },
        archivoDeListaEstaCompleto: function() { 
            const { tabla, textoDelVinculo } = this.formularioAlta.archivos;
            let estaCompleto = false;
            if(this.campoRequeridoEsValido(tabla.archivoObj) && this.campoRequeridoEsValido(textoDelVinculo))
                estaCompleto = true;
            return estaCompleto;
        },
        crearObjArchivoDeContenido: async function() { 
            let archivoConFormato = {};
            // caso para nuevo contenido
            if(!this.formularioAlta.esEdicion) {
                archivoConFormato.id = (this.formularioAlta.archivos.tabla.contadorDeArchivos += 1);
                archivoConFormato.textoVinculo = this.formularioAlta.archivos.textoDelVinculo;
                archivoConFormato.textoVinculoFormatoHTML = `<h6 style="color: #be9a5e;"><strong>${ this.formularioAlta.archivos.textoDelVinculo }</strong></h6>`;
                archivoConFormato.nombre = `<h6><strong>${ this.formularioAlta.archivos.tabla.archivoObj.name }</strong></h6>`;
                archivoConFormato.file = this.formularioAlta.archivos.tabla.archivoObj;
                archivoConFormato.referencia = `ARCHIVO-${ archivoConFormato.id }`;
            }
            return archivoConFormato;
        },
        habilitarCamposDeSesionesEnFormulario: function({ estado }) {
            this.formulario.EsSesion = estado;
            this.formulario.TituloSesion = estado;
            this.formulario.TextoDeSesion = estado;
            this.formulario.FechaDeSesion = estado;
            this.formulario.ListaDeArchivosSesion = estado;
            this.formulario.TextoDelContenido = !estado;
            if(estado)
                this.formulario.Archivo = !estado;
        },
        confirmarPerdidadaDeInformacionEnFormulario: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `Se cierras el formulario se perdera la informacion ingresada en el formulario\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                    this.evtCerrarFormulario({ desdeValidacion: false });
                },
                funcionCancelar: () => {
                    $("#modal-informativo-adminContIntranet").modal('hide');
                    $("#modal-alta-contenido-intranet").modal('show');
                }
            }
            $("#modal-informativo-adminContIntranet").modal('show');
        },
        limpiarFormulario: function({ conSeccionFechas, conSeccionArchivos, conSeccionComunicados, conSeccionClinicas, conSesiones = true, conCatalogoTiposDeDocumentos = true }) {
            // CAMPOS DE SECCION GENERAL DEL CONTENIDO
            this.formularioAlta.textoDelContenido = null;
            this.formularioAlta.textoDelVinculo = null;
            this.formularioAlta.vinculo = null;
            this.formularioAlta.mostrarErrores = false;
            this.formularioAlta.esEdicion = false;
            this.formularioAlta.accesoEsVinculo = false;

            if(conSeccionFechas)
                this.limpiarSeccionFechas();
            if(conSeccionArchivos)
                this.limpiarSeccionArchivos({ conListaDeArchivos: true });
            if(conSeccionComunicados)
                this.limpiarSeccionComunicados();
            if(conSeccionClinicas)
                this.limpiarSeccionClinicas();
            if(conSesiones)
                this.habilitarCamposDeSesionesEnFormulario({ estado: false });
            if(conCatalogoTiposDeDocumentos)
                this.actualizarCatalogo({ tipoCatalogo: this.formularioAlta.catalogoTiposDocumentos });

            this.formularioAlta.PASOS.DOS.mostrar = false;
            this.evtCambioDePaso({ paso: this.formularioAlta.PASOS.UNO });
        },
        limpiarSeccionFechas: function() {
            this.formularioAlta.fechas.fin.fecha = new Date().agregarDias(150);
            this.formularioAlta.fechas.inicio.fechaDefault = new Date();
        },
        limpiarSeccionArchivos: function({ conListaDeArchivos }) {
            this.formularioAlta.archivo.objeto = null;
            $("#archivo_input_individual").val('');
            if(conListaDeArchivos) {
                this.formularioAlta.archivos.lista = [];
                this.formularioAlta.archivos.tabla.archivoObj = null;
                this.formularioAlta.archivos.tabla.archivos = [];
                this.formularioAlta.archivos.textoDelVinculo = null;
                this.formularioAlta.archivos.tabla.contadorDeArchivos = 0;
                this.formularioAlta.archivos.mostrarErrores = false;
                $("#archivo_input_lista").val('');
            }
        },
        limpiarSeccionComunicados: function() {
            this.formularioAlta.imagen.objeto = null,
            this.formularioAlta.comunicado.titulo = null;
            this.formularioAlta.comunicado.subtitulo = null;
            this.formularioAlta.comunicado.fecha = null;
            $("#imagen_comunicado").val('');
        },
        limpiarSeccionClinicas: function() {
            this.formularioAlta.sesion.titulo = null;
            this.formularioAlta.sesion.persona = null;
            this.formularioAlta.sesion.fecha = null;
            this.formularioAlta.sesion.ordenDelDia = null;
            this.formularioAlta.sesion.ponencia = null;
            this.formularioAlta.sesion.actaDeSesion = null;
            $("#archivo_input_ordendeldia").val('');
            $("#archivo_input_ponencia").val('');
            $("#archivo_input_actadesesion").val('');
            this.actualizarCatalogo({ tipoCatalogo: this.formularioAlta.catalogoTiposClinicas });
        },
        actualizarCatalogo: function({ tipoCatalogo, valorDefinido = -1 }) { 
            // Definir siempre las propiedades de actualizacion de los catalogos iguales
            tipoCatalogo.valorDefinido = valorDefinido;
            tipoCatalogo.seleccionado = null;
            tipoCatalogo.contRender ++;
        },
        obtenerHTMLAcciones: () => {
            return [
                '<div>',
                    '<button id="btn-info-contenido-vbdd" title="Editar contenido" type="button" class="btn-edt-cont-intr btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-pen"></i></button>',
                '</div>'
            ].join("");
        },
        obtenerHTMLAccionesArchivos: () => {
            return [
                '<div>',
                    '<button id="btn-remover-archivo-vadcitr" title="copiar" type="button" class="btn-rmv-cont-intr btn btn-light btn-sm btn-xs btn-lg btn-md"><i class="fas fa-minus"></i></button>',
                '</div>'
            ].join("");
        },
        inicializarTablaArchivos: async function() { 
            this.$nextTick(() => {
                $("#" + this.formularioAlta.archivos.tabla.ID).bootstrapTable({  data: this.formularioAlta.archivos.tabla.archivos });      
                $("#" + this.formularioAlta.archivos.tabla.ID).bootstrapTable('load', this.formularioAlta.archivos.tabla.archivos ); 
            });
        },
        habilitarCamposClinicapenal: function() {
            const ES_CLINICA_PENAL = (this.formularioAlta.catalogoTiposClinicas.valorDefinido == this.formularioAlta.catalogoTiposClinicas.CLINICA_PENAL);
            this.formularioAlta.PASOS.DOS.mostrar = ES_CLINICA_PENAL;
            this.habilitarCamposDeSesionesEnFormulario({ estado: ES_CLINICA_PENAL });
        },
        asignarValoresDefaultFormularioClinicas: function({ seccionId, areaIntranetId }) {
            const SECCION_ID_LISTA_CLINICAS = 43;
            this.formularioAlta.catalogoTiposClinicas.valorDefinido = (seccionId == SECCION_ID_LISTA_CLINICAS) ? this.formularioAlta.catalogoTiposClinicas.CLINICAS[areaIntranetId] : -1;
            this.formularioAlta.catalogoTiposClinicas.seleccionado = null;
            this.formularioAlta.catalogoTiposClinicas.contRender ++;
            this.habilitarCamposClinicapenal();
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        // EVENTOS CATALOGOS
        evtPuedeAgregarContenidosListaDeDocumentos: function(tiposDeDocumento) {
            if(!this.campoRequeridoEsValido(tiposDeDocumento)) {
                $("#modal-alta-contenido-intranet").modal('hide');
                this.evtCerrarFormulario({ desdeValidacion: true });
                comun.mensajeDeAlerta('Para comenzar agregar contenidos de la sección [<strong>listado de documentos</strong>] debes tener al menos un contenido tipo de documento en la sección [<strong>Tipos de documento</strong>]');
            }
        },
        evtCambioTipoClinica: function(evento,tipoClinicaObj) {
            // Se asignan los campos del catalogo
            this.formularioAlta.catalogoTiposClinicas.valorDefinido = parseInt(evento.target.value);
            this.formularioAlta.catalogoTiposClinicas.seleccionado = tipoClinicaObj;

            // SE VALIDAN LOS CAMPOS DE CLINICAS PENALES
            this.habilitarCamposClinicapenal();
            //this.inicializarTablaArchivos();
        },
        evtCambioTipoDeDocumento: function(evento,tipoDocumentoObj) {
            // Se asignan los campos del catalogo
            this.formularioAlta.catalogoTiposDocumentos.valorDefinido = parseInt(evento.target.value);
            this.formularioAlta.catalogoTiposDocumentos.seleccionado = tipoDocumentoObj;
        },
        // EVENTOS INPUTS
        evtCambioDePaso: function({ paso }) {
            const PASOS = Object.values(this.formularioAlta.PASOS);
            this.$nextTick(() => { 
                PASOS.forEach(p => { 
                    p.activo = false;
                    $("#" + p.ID).removeClass('paso-activo');   
                });
                $("#" + paso.ID).addClass('paso-activo');  
                paso.activo = true;
            });
        },
        evtSubidorDeImagen: function(evento) {
            try{
                this.formularioAlta.imagen.objeto = evento.target.files[0];
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtSubidorDeArchivo: async function({ evento, esPara }) {
             try {
                const { INDIVIDUAL, LISTA, ORDEN_DEL_DIA, PONENCIA, ACTA_DE_SESION } = this.TIPO_SUBIDOR_ARCHIVOS;
                const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                const ARCHIVO = evento.target.files[0];
                switch(esPara) {
                    case INDIVIDUAL: 
                        this.formularioAlta.archivo.objeto = ARCHIVO;
                        break;
                    case LISTA: 
                        this.formularioAlta.archivos.tabla.archivoObj = ARCHIVO;
                        break;
                    case ORDEN_DEL_DIA: 
                        this.formularioAlta.sesion.ordenDelDia = ARCHIVO;
                        break;
                    case PONENCIA: 
                        this.formularioAlta.sesion.ponencia = ARCHIVO;
                        break;
                    case ACTA_DE_SESION: 
                        this.formularioAlta.sesion.actaDeSesion = ARCHIVO;
                        break;
                    default:
                        break;
                }
                this.formularioAlta.archivo.utilizoSubidor = this.campoRequeridoEsValido(ARCHIVO);
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtSeleccionDeFechaDtPk: function() {
            this.$nextTick(() => {
                let FECHA_INICIO = moment(this.formularioAlta.fechas.inicio.fecha).format(this.formularioAlta.fechas.FORMATO);
                let FECHA_FIN =  moment(this.formularioAlta.fechas.fin.fecha).format(this.formularioAlta.fechas.FORMATO);
                if(FECHA_INICIO > FECHA_FIN) {
                    this.formularioAlta.fechas.fin.fecha = this.formularioAlta.fechas.inicio.fecha;
                    this.formularioAlta.fechas.inicio.fechaDefault = this.formularioAlta.fechas.fin.fecha;
                }
            });
        },
        // EVENTOS ACCIONES
        evtOrdenDeContenidoSeModifico: function(modificado, listaModificada) {
            this.busquedaContenidos.contenidos.ordenamiento.listaNuevoOrden = listaModificada;
            console.log('listaNuevoOrden::',this.busquedaContenidos.contenidos.ordenamiento.listaNuevoOrden);
        },
        evtMostrarModalOredenamientoDeContenidos: function() {
            const FORMATO_FECHAS = 'YYYY-MM-DD';
            this.busquedaContenidos.contenidos.ordenamiento.listaAordenar = this.busquedaContenidos.contenidos.lista.map(contenidoFormatoTabla => {
                let contenidoParaOrdenamiento = {};
                contenidoParaOrdenamiento.ContenidoDeIntreanetId = contenidoFormatoTabla.ContenidoDeIntreanetId;
                contenidoParaOrdenamiento.FechaFinalDeModificacion = `[<i class="fas fa-calendar-day"></i> Fecha de ultima actualización: ${ moment(contenidoFormatoTabla.FechaFinalDeModificacion).format(FORMATO_FECHAS) }]`;
                contenidoParaOrdenamiento.Orden = contenidoFormatoTabla.Orden;
                contenidoParaOrdenamiento.descripcion = `<strong>${ contenidoFormatoTabla.descripcion }</strong>`;
                return contenidoParaOrdenamiento;
            });
            this.ocultarTooltip();
            $("#modal-ordenamiento-contenidosIntranet").modal('show');
        },
        evtRemoverCedulasSeleccionadas: function() {
            this.$nextTick(() => {
                this.busquedaContenidos.contenidos.seleccionados = [];
                $("#" + this.busquedaContenidos.tabla.ID).bootstrapTable('uncheckAll');
            });
        },
        evtBusquedaDeContenidos: async function(parametros) {
            this.busquedaContenidos.filtros.parametros = parametros;
            this.iniciarProcesoBusquedaDeContenidos(parametros);
        },
        evtAgregarArchivoALista: async function() { 
            if(this.archivoDeListaEstaCompleto()) {
                this.formularioAlta.archivos.mostrarErrores = false;
                const ARCHIVO_CON_FORMATO_INFORMATIVO = await Promise.resolve(this.crearObjArchivoDeContenido());
                console.log('archivoTmp::',ARCHIVO_CON_FORMATO_INFORMATIVO);
                // se agrega fila a tabla de archivos
                // Nota metodo insertRow agrega elemento a lista fuente de datos
                $("#" + this.formularioAlta.archivos.tabla.ID).bootstrapTable('insertRow',{
                    index: ARCHIVO_CON_FORMATO_INFORMATIVO.id,
                    row: ARCHIVO_CON_FORMATO_INFORMATIVO
                });

                //se limpian las variables temporales del archivo
                this.formularioAlta.archivos.tabla.archivoObj = null;
                this.formularioAlta.archivos.textoDelVinculo = null;
                $("#archivo_input_lista").val('');
            }
            else {
                this.formularioAlta.archivos.mostrarErrores = true;
            }
        },
        evtCerrarFormulario: function({ desdeValidacion = false }) {
            this.limpiarFormulario({ conSeccionFechas: true, conSeccionArchivos: true, conSeccionComunicados: true, conSeccionClinicas: true, conCatalogoTiposDeDocumentos: !desdeValidacion });
        },
        evtNuevoContenido: function(parametros) { debugger
            console.log('parametros::',parametros);
            this.busquedaContenidos.filtros.elementos = { ...parametros.formulario };
            this.busquedaContenidos.filtros.parametros = { ...parametros };
            this.formularioAlta.esEdicion = false;
            // se asigna el valor para el tipo de clinica
            this.asignarValoresDefaultFormularioClinicas({ seccionId: parametros.seccionId, areaIntranetId: parametros.areaIntranetId });
            // se actualiza catalogo de tipos de documentos
            this.formularioAlta.catalogoTiposDocumentos.parametros.AreaDeIntranetId = this.busquedaContenidos.filtros.parametros.areaIntranetId;
            this.formularioAlta.catalogoTiposDocumentos.contRender ++;
            this.evtFormulario({ tipo: this.FORMULARIOS.ALTA, accion: 'show' })
        },
        evtFormulario: async function({ tipo, accion }) { 
            const { ALTA, EDICION } = this.FORMULARIOS;
            switch(tipo) {
                case ALTA:
                    await Promise.resolve(this.inicializarTablaArchivos());
                    $("#modal-alta-contenido-intranet").modal(accion);
                    break;
                case EDICION:
                    break;
                default:
                    break;
            }
        },
        evtInfoAyuda: function() {
            this.busquedaContenidos.tabla.mostrarAyuda = !this.busquedaContenidos.tabla.mostrarAyuda;
        }
    },
    computed: {
        existeFormulario() {
            return (this.campoRequeridoEsValido(this.busquedaContenidos.filtros.elementos));
        },
        formulario() { debugger
            return this.busquedaContenidos.filtros.elementos;
        },
        numeroDeArchivosEnLista() {
            return this.formularioAlta.archivos.tabla.archivos.length;
        },
        contenidosSeleccionados() {
            return this.busquedaContenidos.contenidos.seleccionados;
        },
        mostrarAccionOrdenamiento() {
            return (this.campoRequeridoEsValido(this.busquedaContenidos.contenidos.lista) && this.busquedaContenidos.contenidos.lista.length >= 2);
        },
        mostrarSwitchDeTipoAcceso() {
            return (this.campoRequeridoEsValido(this.busquedaContenidos.filtros.elementos)) ? (this.busquedaContenidos.filtros.elementos.Vinculo && this.busquedaContenidos.filtros.elementos.Archivo) : false;
        }
    },
    async mounted() {
        let elementosOBJ = [];
        await Promise.resolve(this.inicializarTabla({ elementos: elementosOBJ }));
        window.operateEvents = {
            "click #btn-info-contenido-vbdd": (e,val,row,index) => {         
                //this.accionDetallesDeDocumento({ contenido: row });
            },
            "click #btn-remover-archivo-vadcitr": (e,val,row,index) => {          
                this.removerArchivoDeLista({ archivo: row });
            },
            'click .icono-ampliar-texto': (e, value, row, index) => { 
                //this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
    },
}
</script>
<style scoped>
.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

#lista-ordenamiento-contenidos {
    border: 2px solid rgb(51, 49, 49);
    max-height: 335px;
    overflow: auto;
}

#modal-ordenamiento-contenidosIntranet .modal-lg {
    max-width: 45% !important;
}

#modal-ordenamiento-contenidosIntranet .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-ordenamiento-contenidosIntranet .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

#accion-ordenar {
    margin-bottom: -3.5em; 
    margin-top: 1.3em;
    cursor: pointer;
    color: rgb(185, 185, 185);
}

#accion-ordenar:hover, #accion-ordenar:focus {
    font-weight: bold;
    color: white
}

#seccion-acciones-contSeleccionados {
    padding: 0.6em 2em 0.5em 2em;
    margin-bottom: -1em;
    border-bottom: 1px solid rgb(36, 36, 36);
}

#seccion-acciones-contSeleccionados h6 {
    font-size: 1.2em;
    padding-top: 0.3em;
}

#seccion-acciones-contSeleccionados .btn-danger {
    cursor: pointer;
    background-color: #323335;
    border: none;
}

#seccion-acciones-contSeleccionados .btn-danger:hover, #seccion-acciones-contSeleccionados .btn-danger:focus{
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

#modal-informativo-adminContIntranet .modal-lg {
    max-width: 30% !important;
}

#modal-informativo-adminContIntranet .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#seccion-pasos-formulario {
    /* border: 1px solid rgb(27, 27, 27); */
    padding: 0.5em 0.5em 0.3em 0.5em;
    border-radius: 3px;
}

.paso-formulario {
    background-color: #f8f9fa;
    color: black;
    text-align: center;
    border: 1px solid black;
    cursor: pointer;
    border-radius: 4px;
    padding: 0.5em 1em 0em 1em;
}

.paso-formulario h6 {
    font-size: 2vmin;
}

.paso-formulario h5 {
    font-size: 2.5vmin;
    font-weight: bold;
    margin-bottom: 0.2em;
}

.paso-formulario:focus, .paso-formulario:hover {
    background-color: black;
    color: white;
}

.paso-activo {
    background-color: black;
    color: white;
    border: 1px solid white;
}

.seccion-formulario {
    padding: 1em 2em 1em 2em;
    border-radius: 4px;
    background-color:  #2b2b2e;
    border: solid 1px #676666;
}

.seccion-lista-archivos {
    margin-top: 2em;
}

.titulo-seccion-formulario {
    border: 1px solid rgb(27, 27, 27);
    padding: 0.5em 1em 0.2em 1em;
}

#modal-alta-contenido-intranet .btn-primary {
    background-color: black;
}

#modal-alta-contenido-intranet .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-alta-contenido-intranet .modal-lg {
    max-width: 50% !important;
}

#modal-alta-contenido-intranet .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

.i-info {
    font-size: 3vmin;
    cursor: pointer;
}

#encabezados {
    margin-bottom: 4em;
}

#encabezados h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

.titulo-contenedores h5 {
    font-size: 2.7vmin;
}

.titulo-contenedores {
    background-color: rgb(80, 80, 80);
    padding: 1.3em 2em 0.5em 2em;
    color: white;
    border-bottom: 1px solid rgb(27, 27, 27);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.contenedor-color-negro {
    background-color: #323335;
    padding: 25px;
    border: 1px solid rgb(27, 27, 27);
    border-radius: 4px;
}

.contenedor-tabla-contenidos-intranet {
    padding: 1.5em 2em 3em 2em;
}
</style>
<style>
.contenedor-tabla-contenidos-intranet .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.contenedor-tabla-contenidos-intranet .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.contenedor-tabla-contenidos-intranet td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.contenedor-tabla-contenidos-intranet .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}

/* .contenedor-tabla-contenidos-intranet .btn-light:hover, .contenedor-tabla-contenidos-intranet .btn-light:focus {
    background-color: #4F4949;
    border: 1px solid #4F4949;
    color: white;
} */

.contenedor-tabla-contenidos-intranet .btn-edt-cont-intr:hover, .contenedor-tabla-contenidos-intranet .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.contenedor-tabla-contenidos-intranet .btn-rmv-cont-intr:hover, .contenedor-tabla-contenidos-intranet .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.contenedor-tabla-contenidos-intranet table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.contenedor-tabla-contenidos-intranet .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.contenedor-tabla-contenidos-intranet .pagination > li > a {
    background-color: white;
    color: #121213;
}

.contenedor-tabla-contenidos-intranet .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.contenedor-tabla-contenidos-intranet > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

.inhabilitado {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Intranet/Contenidos/CAdministracionDeContenidos.vue